// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"68f17934","388":"1f8d96a3","453":"6fad46e6","520":"920130c7","879":"c97387f4","994":"03c929eb"}[chunkId] + ".chunk.js";
};